export const getPayoutIncentivesItems = ({
  dynamicPricing,
  instantBooking,
  deliveryAirport,
  features,
  highQualityPhotos,
  longTripDiscountAvailable,
  unlimitedMileage,
} = {}) => [
  {
    title: 'Instant booking',
    amount: 2,
    active: instantBooking && instantBooking.available,
  },
  {
    title: 'High quality photos',
    amount: 2,
    active: !!highQualityPhotos,
    availableThroughSupport: true,
  },
  {
    title: 'Airport delivery',
    amount: 2,
    active: !!deliveryAirport,
  },
  {
    title: 'Dynamic pricing',
    amount: 2,
    active: dynamicPricing,
  },
  {
    title: 'Full Self Driving',
    amount: 2,
    active: features?.some((f) => f.icon === 'full-self-driving') ?? false,
  },
  {
    title: 'Unlimited mileage',
    amount: 1,
    active: unlimitedMileage,
  },
  {
    title: 'Long rental discount',
    amount: 1,
    active: longTripDiscountAvailable,
  },
];
